import {
  useDisclosure,
} from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react';
import "./metka.css"
import "./metkaDark.css"
import { useSelector } from 'react-redux';
export default function MetkaEdit({ setMetka, metka }) {
  const { isOpen, onToggle, onClose, onOpen } = useDisclosure();
  const [metkaVal, setMetkaVal] = useState("");
  const [MetkaData, setMetkaData] = useState([]);
  const getDarkModoe = useSelector(darkModes => darkModes );
  const metkaRef = useRef(null);
const modalMetka = useRef(null);

  const addMetka = (e) => {

    if (e.key === "Enter") {
      setMetka(metka => [...metka, metkaVal])

      setMetkaVal("")



    }

  }

  const addMetkaBtn = (e) => {

    setMetka(metka => [...metka, metkaVal])

      setMetkaVal("")

  }
  

  const handleDelete = (index) => {

    const deleteMetka = metka.filter((_, i) => i !== index);

    setMetka(deleteMetka);
  };
useEffect(()=>{
  modalMetka.current.style.display = "none";
},[])

  const handelOpenModal=()=>{
    modalMetka.current.style.display = "flex";
  }


  const handelCloseModal=()=>{
    modalMetka.current.style.display = "none";
  }

  return (
    <>
      <div id="myModal" ref={modalMetka} className={getDarkModoe.ToggleDarkModeReducer.chekced?"modalMetkaDark":"modalMetka"}>


        <div className="modal-contentMetka">
          <div className="modal-headerMetka">
          <h2>Теги</h2>
            <span className="closeMetka" onClick={handelCloseModal}>&times;</span>
            
          </div>
          <div className="modal-bodyMetka">
              <div className='BntInputContTag' >
              <input
              size="sm"
              type="text"
              placeholder="Название тега"
              value={metkaVal}
              isOpen={isOpen}
              onOpen={onOpen}
              onClose={onClose}
              placement="right"
              closeOnBlur={false}
              color={"#ACACB0"}
              onChange={(e) => setMetkaVal(e.target.value)}
              onKeyDown={addMetka}
            />
            <div className='addTagBtn' onClick={addMetkaBtn}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path opacity="0.3" d="M15 5C9.4875 5 5 9.4875 5 15C5 20.5125 9.4875 25 15 25C20.5125 25 25 20.5125 25 15C25 9.4875 20.5125 5 15 5ZM21.25 16.25H16.25V21.25H13.75V16.25H8.75V13.75H13.75V8.75H16.25V13.75H21.25V16.25Z" fill="white"/>
                <path d="M16.25 8.75H13.75V13.75H8.75V16.25H13.75V21.25H16.25V16.25H21.25V13.75H16.25V8.75ZM15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5ZM15 25C9.4875 25 5 20.5125 5 15C5 9.4875 9.4875 5 15 5C20.5125 5 25 9.4875 25 15C25 20.5125 20.5125 25 15 25Z" fill="white"/>
              </svg>
            </div>
              </div>
           
            <div >
              {metka?.map((item, index) => {
                return (
                  <div key={index} className='metkaListInModal'>
                    <p className='metkaNameInModalList' key={index}>#{item}</p>
                    <span class="material-symbols-outlined" style={{ color: "#DB5F95", cursor: "pointer" }} onClick={(e) => handleDelete(index)}>delete</span>
                    

                  </div>
                )
              })}
            </div>
          </div>
          
        </div>

      </div>
      <div className="metka">
        <div className='metkaCont'>
          {metka?.map((item, index) => {
              if (index < 3) {
                return (
                  <div key={index}>
                    <p key={index}>#{item}</p>
                  
    
                  </div>
                )
              }
           
          })}
        </div>
        <div className='BNTcONT' onClick={handelOpenModal}>
          <button  >Теги</button>
          <span class="material-symbols-outlined">
            crop_square
          </span>
        </div>





      </div>
    </>
  )
}